import React from 'react';
import classnames from 'classnames';
import { BiEvent } from '@wix/da-bi/pkg/events';
import {
  ThemeOptions,
  ThemeOverride,
} from '@wix/da-react-context/pkg/ThemeContext';
import { Props as IconProps } from '../../../Icons/IconWrap';
import SolidButton from '../../../Buttons/SolidButton';
import BrandedButton from '../../../Buttons/BrandedButton';
import s from './ThumbMiddleContent.scss';

interface Props {
  icon?: React.ReactNode;
  title?: string;
  subtitle?: string | React.ReactNode;
  buttonTitle?: string | React.ReactNode;
  className?: string;
  biData?: BiEvent;
  buttonHref?: string;
  onButtonClick?: (e: React.MouseEvent) => void;
  buttonStyle?: 'solid' | 'branded';
  buttonIcon?: React.ComponentType<IconProps>;
  buttonClassname?: string;
}

const ThumbMiddleContent: React.FC<Props> = ({
  icon,
  title,
  subtitle,
  buttonTitle,
  onButtonClick,
  biData,
  className,
  buttonHref,
  buttonStyle,
  buttonIcon,
  buttonClassname,
}) => {
  const ButtonComponent = buttonStyle === 'solid' ? SolidButton : BrandedButton;

  return (
    <ThemeOverride
      theme={ThemeOptions.DARK}
      tag="div"
      className={classnames(s['root'], className)}
    >
      {icon && <div className={s['icon']}>{icon}</div>}
      {title && <div className={s['title']}>{title}</div>}
      {subtitle && <div className={s['subtitle']}>{subtitle}</div>}
      {buttonTitle && (
        <ButtonComponent
          variant={(buttonStyle === 'solid' ? 'main' : 'brand-green') as any}
          icon={buttonIcon}
          size="medium"
          onClick={onButtonClick}
          href={buttonHref}
          biData={biData}
          className={classnames(s['button'], buttonClassname)}
        >
          {buttonTitle}
        </ButtonComponent>
      )}
    </ThemeOverride>
  );
};
ThumbMiddleContent.displayName = 'ThumbMiddleContent';

export default ThumbMiddleContent;
